import { useEffect } from 'react';
import { usePlugin } from '~/plugins/pluginContext';
import { State } from '../state/types/state';

export const useResultsChange = ({ state, isDebugMode }: { state: State; isDebugMode: boolean }) => {
    const { doAction } = usePlugin();
    useEffect(() => {
        if (state.searchQuery.length < 2) {
            return;
        }
        doAction(
            'afterResultsUpdate',
            { count: state.results.totalRecordsCount, searchQuery: state.searchQuery },
            isDebugMode
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.results]);
};
